<template>
  <a-layout class="pr-layout-wrap">
    <div class="open-video" v-if="preface">
      <video id="pvideo" controls>
        <source
          src="https://cdn.projectroar.cn/first_login_video.mp4"
          type="video/mp4"
        />
      </video>
      <close-square-outlined
        class="btn-video-close"
        @click="preface = false"
        v-if="showClose"
      />
    </div>
    <!-- <div v-if="preface">1</div> -->
    <template v-else>
      <PrHeader />
      <a-layout>
        <pr-sider />
        <a-layout-content>
          <vab-content />
          <PrLayoutFooter />
        </a-layout-content>
      </a-layout>
    </template>
  </a-layout>
</template>
<script>
  import VabContent from './vab-content'
  import PrSider from './pr-sider'
  import PrLayoutFooter from './pr-footer'
  import PrHeader from './pr-header'
  import 'remixicon/fonts/remixicon.css'
  import { CloseSquareOutlined } from '@ant-design/icons-vue'

  export default {
    components: {
      VabContent,
      PrHeader,
      PrSider,
      PrLayoutFooter,
      CloseSquareOutlined,
    },
    data() {
      return {
        showClose: false,
        preface: localStorage.getItem('roar_preface') != 'false',
      }
    },
    mounted() {
      console.log(localStorage.getItem('roar_preface'));
      if (this.preface) {
        const video = document.getElementById('pvideo')
        const videoErrorHandel = setTimeout(() => {
          this.preface = false
        }, 10000)

        video.addEventListener('canplay', () => {
          video.play()
          clearTimeout(videoErrorHandel)
          localStorage.setItem('roar_preface', false)
          setTimeout(() => {
            this.showClose = true
          }, 5000)
        })
        video.addEventListener('ended', () => {
          this.preface = false
        })
      }
    },
  }
</script>
<style lang="less">
  @import url('@/styles/params.less');
  .pr-layout-wrap {
    .pr-layout-header {
      background-color: black;
      height: @app-header-height;
      padding: 17px 25px;
      display: flex;
      align-items: center;
      .header-logo {
        width: 167px;
        height: 26px;
        display: flex;
        margin-right: 36px;
        img {
          object-fit: contain;
          height: 100%;
        }
      }
      .header-message {
        color: white;
        &-content {
          display: flex;
          align-items: center;
        }
        .svg-icon {
          color: white;
          // margin: 0 8px;
        }
        .hm-msg-icon {
          font-size: 24px;
        }
        .hm-arrow-icon {
          margin-left: 15px;
          font-size: 10px;
        }
      }
    }
  }
  .app-breadcrumb {
    background-color: white;
    padding: 12px 32px 12px 32px;
    font-size: 14px;
    color: #666666;
    .page-header {
      display: flex;
      justify-content: space-between;
      margin: 10px 0 4px 0;
    }
    .page-remark {
      display: flex;
      align-items: center;
    }
    .page-title {
      font-size: 20px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 28px;
      font-weight: bold;
    }
  }
  .open-video {
    background-color: black;
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    video {
      width: 100%;
    }
    .btn-video-close {
      position: absolute;
      top: 30px;
      color: rgb(233, 233, 233);
      opacity: 0.3;
      right: 30px;
      font-size: 30px;
      z-index: 99999;
    }
  }
</style>
